import { useEffect, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import styled from "styled-components";
import { exchangePartnerTicket, savePartnerGuestSession } from "../api/partnerLinkAPI";
import { clearPartnerGuestSession } from "../api/api";
import { getLoginUser } from "../api/user";
import { ACCESS_TOKEN } from "../lib/cookie";
import InvalidLinkScreen from "../component/common/InvalidLinkScreen";

/**
 * 협력 사이트(OCSPST)에서 넘어오는 진입 페이지 - /partner-entry#ticket=...
 * 티켓은 URL fragment 로 받아(서버 로그/Referer 에 남지 않음) 바로 주소에서 지운 뒤 게스트 토큰으로 교환한다.
 * ATLAS 회원으로 이미 로그인되어 있으면 게스트 세션 없이 회원 권한으로 게시글을 연다.
 */
const PartnerEntry = () => {
  const navigate = useNavigate();
  const [errorMsg, setErrorMsg] = useState<string | null>(null);

  // 티켓은 1회용이라 StrictMode 의 effect 재실행에도 한 번만 교환되도록 ref 로 잡아둔다
  const ticketRef = useRef<string | null | undefined>(undefined);
  if (ticketRef.current === undefined) {
    ticketRef.current = new URLSearchParams(window.location.hash.slice(1)).get("ticket");
  }
  const startedRef = useRef(false);

  useEffect(() => {
    if (startedRef.current) return;
    startedRef.current = true;

    window.history.replaceState(null, "", window.location.pathname);

    const ticket = ticketRef.current;
    if (!ticket) {
      setErrorMsg("링크에 열람 정보가 없습니다.");
      return;
    }

    const enter = async () => {
      try {
        clearPartnerGuestSession();
        const result = await exchangePartnerTicket(ticket);

        const loginUser = localStorage.getItem(ACCESS_TOKEN) ? await getLoginUser() : null;
        const isMember = !!(loginUser && !Array.isArray(loginUser) && loginUser.id);
        if (!isMember) savePartnerGuestSession(result);

        navigate(`/post/${result.postId}`, { replace: true });
      } catch (e) {
        setErrorMsg(e instanceof Error ? e.message : "링크를 확인하지 못했습니다.");
      }
    };
    enter();
  }, []);

  if (errorMsg) {
    return (
      <InvalidLinkScreen
        title={errorMsg}
        desc="링크는 한 번만, 짧은 시간 동안 사용할 수 있습니다. 소아고형암 온라인 자문시스템에서 링크를 다시 눌러주세요."
      />
    );
  }

  return (
    <Container>
      <Box>
        <Desc>링크를 확인하는 중...</Desc>
      </Box>
    </Container>
  );
};

const Container = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100vh;
  background-color: #0a1929;
`;

const Box = styled.div`
  text-align: center;
  padding: 48px 64px;
  background-color: #051e34;
  border: 1px solid #1e3a52;
  border-radius: 12px;
  min-width: 320px;
`;

const Desc = styled.p`
  color: #8899aa;
  font-size: 0.95rem;
  margin: 0;
`;

export default PartnerEntry;
